module.exports = __webpack_public_path__ + "img/img25.8019569e.svg";